import * as CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = 'ca11c1086a57d69b90178c73eb5aeec88142ab38f955f85b8d8d8db2180a6bc8'; // 64 chars hex = 32 bytes
const ENCRYPTION_IV = '0f2c1f232a3ccc806317b7065adfc8be'; // 32 chars hex = 16 bytes

const key = CryptoJS.enc.Hex.parse(ENCRYPTION_KEY);
const iv = CryptoJS.enc.Hex.parse(ENCRYPTION_IV);

export function encryptAES(plainText: string): string {
  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString(); // En base64
}
